import React from 'react';
import { HomeSectionScreenProps } from '../Home';
import './Companies.scss';
import { CompaniesList } from './CompaniesList';

export const Companies: React.FC<HomeSectionScreenProps> = ({ screenId }) => {
  return (
    <div className='companies' id={screenId}>
      <div className='companies__content'>
        <CompaniesList companies={TOP_SIDE_COMPANIES} />
        <div>
          <h3>
            ACROSS ALL
            <br />
            <b>INDUSTRY</b> | <b>COMPANY</b> | <b>CHALLENGE.</b>
            <br />
          </h3>
          <h3>
            <span className='text-emphasis'>
              We work with <span className='highlight'>everyone.</span>
            </span>
          </h3>
        </div>
        <CompaniesList companies={BOTTOM_SIDE_COMPANIES} />
      </div>
    </div>
  );
};

// constants
const TOP_SIDE_COMPANIES = [
  'STARBUCKS COFFEE',
  'HALLIBURTON',
  'DIAMOND OFFSHORE',
  'MARATHON',
  'JPMC',
  'B3 INSIGHTS',
  'REACHAT',
  'ANA HEALTH',
  'SCI',
  'DURASERV',
  'EXPRESS PROFESSIONAL',
  'EXXON',
  'XECTA',
  'HUMANGO',
  'FORTIFY IT',
  'MOONFLOWER FARMS',
  'SLB',
];

const BOTTOM_SIDE_COMPANIES = [
  'TENARIS',
  'QUANTUM ENERGY',
  'CONOCOPHILLIPS',
  'C4WORKX',
  'GE OIL AND GAS',
  'SQUATZ',
  'BAKER HUGHES',
  'CHEVRON',
  'ENDURANCE',
  'MD ANDERSON',
  'CHASE',
  'TELUS',
  'BENJAMIN MOORE',
  'MICHELLIN',
  'METLIFE',
  'TOYOTA',
  'CADENCE BANK',
  'WEATHERFORD',
];
